export default __webpack_public_path__ + "static/security-simplified-e15acd0a1c50c5d62a7809bfba1ebeef.svg";